export default __webpack_public_path__ + "static/media/SG-LightBlue-0007.c84cf763.png";